// src/aws/guestCredentialProvider.js
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";

export const REGION = "eu-west-1"; // Your region
export const IDENTITY_POOL_ID = "eu-west-1:9735e824-f04a-4c3c-84ad-ccac69ef5480"; // Your pool ID

export const guestCredentialProvider = fromCognitoIdentityPool({
  client: new CognitoIdentityClient({ region: REGION }),
  identityPoolId: IDENTITY_POOL_ID,
});
